import React, { useEffect, useState } from 'react'
import PropertiesCard from '../components/Properties/main'
import ApartmentList from '../components/Apartment/main';
import ApartmentCard from '../components/Apartment/card';


const ApartmentPage = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);
  
  return (
    <div className={`flex transition-opacity duration-500 ${fadeIn ? 'opacity-100' : 'opacity-0'}`}>
      <ApartmentCard />
    </div>
  )
}

export default ApartmentPage